export default __webpack_public_path__ + "static/media/cesto_broccoli.a5ab98e5.svg";